import { defineMessages, useIntl } from 'react-intl';

import { DescriptionList } from '@/shared/view/DescriptionList';

type Props = {
  className: string;
  operator: 'wheely_tech' | 'wheely_london';
};

const messages = defineMessages({
  title: {
    defaultMessage: 'Contract Details',
    id: 'profile_contract_details_title',
  },
  entityTitle: {
    defaultMessage: 'Operating Entity',
    id: 'profile_operating_entity_title',
  },
  operatorTechnology: {
    defaultMessage: 'Wheely Technologies Ltd',
    id: 'global_wheely_tech',
  },
  operatorLondon: {
    defaultMessage: 'Wheely London Ltd',
    id: 'global_wheely_london',
  },
});

export const ContractDetails = ({ className, operator }: Props) => {
  const intl = useIntl();

  return (
    <DescriptionList
      title={intl.formatMessage(messages.title)}
      className={className}
      values={{
        operatingEntity: intl.formatMessage(
          operator === 'wheely_tech' ? messages.operatorTechnology : messages.operatorLondon,
        ),
      }}
      titles={[['operatingEntity', intl.formatMessage(messages.entityTitle)]]}
    />
  );
};
